import { Component, OnInit, Input, Output, EventEmitter, OnChanges, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { StockInoutService } from '../../../service/stock-inout/stock-inout.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { isDate } from '../../../util/util';
import { config } from '../../../util/config';
import { validation } from 'app/util/validation';

@Component({
  selector: 'wa6022',
  templateUrl: 'wa6022.component.html',
  styleUrls: ['wa6022.component.scss']
})
export class Wa6022Component implements OnInit, OnChanges {
  public componentTitle = 'WA6022:受払修正';

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  // Define each input element (initial value and validation rule)
  public notinvoiceFl = new FormControl(0, [Validators.min(0), Validators.max(1)]);
  public stockinoutmemoTx = new FormControl('', [Validators.maxLength(validation.stockinoutmemoTx.maxLength)]);
  // build FormGroup
  myForm = this.builder.group({
    notinvoiceFl: this.notinvoiceFl,
    stockinoutmemoTx: this.stockinoutmemoTx
  });

  // other variables
  public stockinoutId: number;
  public ownerTx: string;
  public originalDt = new Date().toJSON().slice(0, 10);
  public bookDt = new Date().toJSON().slice(0, 10);
  public locaCd: string;
  public locaTx: string;
  public locablockTx: string;
  public itemCd: string;
  public itemTx: string;
  public typestockTx: string;
  public lotTx: string;
  public uselimitDt: string;
  public unitTx: string;
  public amountNr: number;
  public pcsNr: number;
  public typeoperationTx: string;
  public refnoTx: string;
  public typetrnTx: string;
  public typetrnsubTx: string;

  private errorInfo = '';

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  @ViewChild('scrollContent')
  scrollContent: ElementRef;

  private originalDtCls = '';
  private bootDtCls = '';
  private stockinoutmemoTxCls = '';
  private notinvoiceFlCls = '';
  private isSubmitButtonEnabled = false;

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private stockInoutService: StockInoutService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  ngOnInit(): void { }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  onSubmit() {
    if (!this.isSubmitButtonEnabled)
      return;

    if (!isDate(this.originalDt)) {
      this.errorInfo = '発生日の書式が不適切です';
      return;
    }
    if (!isDate(this.bookDt)) {
      this.errorInfo = '計上日の書式が不適切です';
      return;
    }
    if (this.myForm.invalid) return;

    this.working = true;
    const originalDt = new Date(this.originalDt);
    const originalDateTx = originalDt.getFullYear() + '/' + ('0' + (originalDt.getMonth() + 1)).slice(-2) + '/' + ('0' + originalDt.getDate()).slice(-2);
    const bookDt = new Date(this.bookDt);
    const bookDateTx = bookDt.getFullYear() + '/' + ('0' + (bookDt.getMonth() + 1)).slice(-2) + '/' + ('0' + bookDt.getDate()).slice(-2);

    this.stockInoutService
      .put({
        stockinoutId: this.stockinoutId,
        originalDt: originalDateTx,
        bookDt: bookDateTx,
        notinvoiceFl: this.notinvoiceFl.value,
        stockinoutmemoTx: this.stockinoutmemoTx.value,
        updprogramCd: 'wa6022'
      })
      .then(outputJson => {
        this.working = false;
        sessionStorage.removeItem('rowStockinout');
        this.closeButtonClick.emit(true);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  cancel() {
    sessionStorage.removeItem('rowStockinout');
    this.closeButtonClick.emit(false);
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.errorInfo = '';
      this.renderAndSetData();
    } else {
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  ngDoCheck() {
    if (!this.isShow)
      return;

    const stockinout: object = JSON.parse(sessionStorage.getItem('rowStockinout'));

    this.originalDtCls = this.originalDt === stockinout['originalDt'] ? '' : 'active';
    this.bootDtCls = this.bookDt === stockinout['bookDt'] ? '' : 'active';
    this.notinvoiceFlCls = this.notinvoiceFl.value == stockinout['notinvoiceFl'] ? '' : 'active';
    this.stockinoutmemoTxCls = this.stockinoutmemoTx.value === stockinout['stockinoutmemoTx'] ? '' : this.stockinoutmemoTx.errors == null ? 'active' : 'error';
    if (
      this.stockinoutmemoTxCls !== 'error'
    )
      this.isSubmitButtonEnabled =
        this.originalDtCls === 'active' || this.bootDtCls === 'active' || this.stockinoutmemoTxCls === 'active' || this.notinvoiceFlCls === 'active';
    else
      this.isSubmitButtonEnabled = false;

  }

  renderAndSetData() {
    const stockinout: object = JSON.parse(sessionStorage.getItem('rowStockinout'));

    this.stockinoutId = stockinout['stockinoutId'];
    this.ownerTx = stockinout['ownerTx'];
    this.originalDt = stockinout['originalDt'];
    this.bookDt = stockinout['bookDt'];
    this.locaCd = stockinout['locaCd'];
    this.locaTx = stockinout['locaTx'];
    this.locablockTx = stockinout['locablockTx'];
    this.itemCd = stockinout['itemCd'];
    this.itemTx = stockinout['itemTx'];
    this.typestockTx = stockinout['typestockTx'];
    this.lotTx = stockinout['lotTx'];
    this.uselimitDt = stockinout['uselimitDt'];
    this.unitTx = stockinout['unitTx'];
    this.amountNr = stockinout['amountNr'];
    this.pcsNr = stockinout['pcsNr'];
    this.typeoperationTx = stockinout['typeoperationTx'];
    this.refnoTx = stockinout['refnoTx'];
    this.typetrnTx = stockinout['typetrnTx'];
    this.typetrnsubTx = stockinout['typetrnsubTx'];
    this.notinvoiceFl.setValue(stockinout['notinvoiceFl']);
    this.stockinoutmemoTx.setValue(stockinout['stockinoutmemoTx']);

    setTimeout(() => {
      this.scrollContent.nativeElement.scrollTop = 0;
    }, 200);
  }

  clrErr() {
    this.errorInfo = '';
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa6Stock/wa6022/wa6022.component.ts